import { render, staticRenderFns } from "./Analysis.vue?vue&type=template&id=2f68ae6a&scoped=true"
import script from "./Analysis.vue?vue&type=script&lang=js"
export * from "./Analysis.vue?vue&type=script&lang=js"
import style0 from "./Analysis.vue?vue&type=style&index=0&id=2f68ae6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f68ae6a",
  null
  
)

export default component.exports